import UserForm from "./UserForm";
import {useDispatch} from "react-redux";
import {useEffect, useState} from "react";
import {deleteUser, fetchRight, updateUser} from "../../../redux/slices/users";
import {toast} from "react-toastify";
import {useFirestoreConnect} from "react-redux-firebase";

export default function EditUser({open, onClose, user}) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)

    useFirestoreConnect(() => [
        {collection: 'users', storeAs: 'userList'}
    ])
    const handleSubmit = (data) => {
        console.log(data)
       /* dispatch(updateUser({
            data: data, resolve: () => {
                setLoading(false)
                toast.success('Fait')
                onClose && onClose()
            }
        }))*/
    }
    const handleDeletion = () => {
        dispatch(deleteUser({
            id: user.id, resolve: () => {
                toast.success('fait')
                onClose && onClose()
            }
        }))
    }

    return (
        <>
            <UserForm
                open={open}
                user={user}
                onClose={onClose}
                onSubmit={handleSubmit}
                loading={loading}
                title={"Editer un utilisateur"}
                // deleteOpt
                onDelete={handleDeletion}
            />
        </>

    )
}